/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'billable_tooltip': 'Abrechenbarer Zeiteintrag',
    'billed': 'Abgerechnet',
    'billed_tooltip': 'Dieser Eintrag wurde bereits abgerechnet',
    'create_project': 'Projekt Erstellen',
    'delete_project': 'Projekt Löschen',
    'delete_project_message': 'Soll das Projekt wirklich gelöscht werden? Alle Zeiteinträge des Projekts bleiben erhalten.',
    'edit_project': 'Project Bearbeiten',
    'estimated_hours': 'Geschätzter Aufwand',
    'export_timereport': 'Auswertung als PDF speichern',
    'hourly_rate': 'Stundensatz',
    'no_date_time_selected': 'Keine Zeitspanne',
    'no_description': '(Keine Beschreibung)',
    'no_open_project_hours': 'Keine offenen Stunden',
    'no_projects_found': 'Keine Projekte gefunden',
    'no_time_entries': 'Keine Zeiteinträge erfasst',
    'no_time_entries_badge': 'Nicht gestartet',
    'no_time_entries_found': 'Keine Zeiteinträge gefunden',
    'not_billed': 'Nicht abgerechnet',
    'open_hour': 'Offene Stunde | Offene Stunden',
    'project': 'Projekt | Projekte',
    'project_billable_hours': 'Abrechenbare Stunden',
    'project_budget': 'Budget',
    'project_date': 'Projektdatum',
    'project_no_customer': 'Kein Kunde',
    'project_start_date': 'Startdatum',
    'project_status_filter': {
      'active': 'Aktive Projekte',
      'inactive': 'Archivierte Projekte'
    },
    'project_type': 'Projektart',
    'project_type_fixed_fee': 'Festpreis',
    'project_type_non_billable': 'Nicht abrechenbar',
    'project_type_time_and_materials': 'Stundenbasierte Abrechnung',
    'projects_empty': 'Keine Projekte vorhanden',
    'recent_time_entries': 'Letzte Zeiteinträge',
    'report': 'Bericht',
    'running': 'Läuft',
    'settle_customer_projects': 'Alle Projekte abrechnen',
    'settle_hours': 'Abrechnen',
    'settle_project': 'Projekt abrechnen',
    'settle_project_modal_grouping': 'Wie sollen die Zeiteinträge auf der Rechnung dargestellt werden?',
    'settle_project_modal_grouping_activity': 'Einträge nach Tätigkeit gruppieren',
    'settle_project_modal_grouping_all': 'Einträge zu einem Eintrag zusammenfassen',
    'settle_project_modal_grouping_fixed': 'Übernehme Festpreis von Projekt',
    'settle_project_modal_grouping_individual': 'Alle Einträge einzeln anzeigen',
    'settle_project_modal_grouping_individual_confirmation': 'Auf der Rechnung werden insgesamt {entries} einzelne Einträge stehen. Möchtest du mit dieser Auswahl fortfahren?',
    'settle_project_modal_rounding': 'Rundung der Einträge',
    'start': 'Start',
    'start_before_end': 'Start muss vor Stop liegen',
    'start_new_time_entry': 'Neuen Zeiteintrag starten',
    'start_time_entry': 'Zeiterfassung starten',
    'stop': 'Stop',
    'time_entries_list_mode': {
      'all': 'Alle Einträge anzeigen',
      'user': 'Meine Einträge anzeigen'
    },
    'time_entry_deleted': 'Der Eintrag wurde gelöscht | Die Einträge wurden gelöscht',
    'time_entry_insufficient_permissions_warning': 'Du kannst diesen Eintrag nicht bearbeiten, da er von jemand anderen erstellt wurde.',
    'time_entry_running': 'Ein Zeiteintrag läuft bereits',
    'time_entry_running_question': 'Es existiert bereits ein laufender Zeiteintrag. Möchtest du den laufenden Eintrag stoppen und einen neuen starten?',
    'time_tracking': 'Zeiterfassung',
    'time_tracking_filter_billed': 'Abgerechnet',
    'time_tracking_filter_project_id': 'Projekt',
    'time_tracking_filter_started_at_end': 'Bis',
    'time_tracking_filter_started_at_start': 'Von',
    'time_tracking_filter_user_id': 'Benutzer',
    'without_customer': 'Ohne Kunde',
    'without_project': 'Ohne Projekt',
    'working_on': 'Woran arbeitest Du gerade?'
  },

  /* english */
  en: {
    'billable_tooltip': 'Billable Time Entry',
    'billed': 'Billed',
    'billed_tooltip': 'This entry has already been billed',
    'create_project': 'Create Project',
    'delete_project': 'Delete Project',
    'delete_project_message': 'Do you really want to delete the project? Project-related time entries will not be removed.',
    'edit_project': 'Edit Project',
    'estimated_hours': 'Estimated Hours',
    'export_timereport': 'Download Report as PDF',
    'hourly_rate': 'Hourly Rate',
    'no_date_time_selected': 'No Timerange',
    'no_description': '(No Description)',
    'no_open_project_hours': 'No unbilled hours',
    'no_projects_found': 'No Projects found',
    'no_time_entries': 'No time entries tracked',
    'no_time_entries_badge': 'Not started',
    'no_time_entries_found': 'No time entries found',
    'not_billed': 'Not billed',
    'open_hour': 'Unbilled Hour | Unbilled Hours',
    'project': 'Project | Projects',
    'project_billable_hours': 'Billable Hours',
    'project_budget': 'Budget',
    'project_date': 'Project Date',
    'project_no_customer': 'No Customer',
    'project_start_date': 'Start Date',
    'project_status_filter': {
      'active': 'Active Projects',
      'inactive': 'Archived Projects'
    },
    'project_type': 'Project Type',
    'project_type_fixed_fee': 'Fixed Fee',
    'project_type_non_billable': 'Non-Billable',
    'project_type_time_and_materials': 'Time & Materials',
    'projects_empty': 'No Projects',
    'recent_time_entries': 'Recent Time Entries',
    'report': 'Report',
    'running': 'Running',
    'set_time': 'Choose Date and Time',
    'settle_customer_projects': 'Settle all projects',
    'settle_hours': 'Settle Hours',
    'settle_project': 'Settle Project',
    'settle_project_modal_grouping': 'How do you want your time entries to be displayed on the invoice?',
    'settle_project_modal_grouping_activity': 'Group time entries by activity',
    'settle_project_modal_grouping_all': 'Sum up all time entries to a single one',
    'settle_project_modal_grouping_fixed': 'Use fixed budget from the project',
    'settle_project_modal_grouping_individual': 'Display all entries individually',
    'settle_project_modal_grouping_individual_confirmation': 'The invoice will contain a total of {entries} entries. Do you really want to continue with this selection?',
    'settle_project_modal_rounding': 'Rounding of the time entries',
    'start': 'Start',
    'start_before_end': 'start must be before stop',
    'start_new_time_entry': 'Start new Entry',
    'start_time_entry': 'Start Time Tracking',
    'stop': 'Stop',
    'time_entries_list_mode': {
      'all': 'Show All Entries',
      'user': 'Show My Entries'
    },
    'time_entry_deleted': 'Time entry deleted | Time entries deleted',
    'time_entry_insufficient_permissions_warning': 'You can not edit this time entry because someone else created it.',
    'time_entry_running': 'Time Entry is Running',
    'time_entry_running_question': 'There already is a running time entry. Do you want to stop running entry and start a new one?',
    'time_tracking': 'Time Tracking',
    'time_tracking_filter_billed': 'Billed',
    'time_tracking_filter_project_id': 'Project',
    'time_tracking_filter_started_at_end': 'To',
    'time_tracking_filter_started_at_start': 'From',
    'time_tracking_filter_user_id': 'Member',
    'without_customer': 'Without Customer',
    'without_project': 'Without Project',
    'working_on': 'What are you working on?'
  }
}
